var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBewegen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Bewegen__Icn/40px/Bewegen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Bewegen__Color/20px/Platzhalter-Transparent",
    transform: "translate(10 10)",
    fillRule: "nonzero",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Bewegen__Rectangle",
    d: "M0 0H20V20H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.1926654,25.0732289 L27.1926654,21.6882289 L28.6886654,21.6882289 L28.6886654,27.6572289 L22.6886654,27.6572289 L22.7736654,26.1832289 L26.1546654,26.1832289 L21.1398034,21.5783415 L22.5098034,20.2083415 L27.1926654,25.0732289 Z M13.8041608,25.0732289 L13.8041608,21.6882289 L12.3081608,21.6882289 L12.3081608,27.6572289 L18.3081608,27.6572289 L18.2231608,26.1832289 L14.8421608,26.1832289 L19.8570228,21.5783415 L18.4870228,20.2083415 L13.8041608,25.0732289 Z M27.1926654,13.8568249 L27.1926654,17.2418249 L28.6886654,17.2418249 L28.6886654,11.2728249 L22.6886654,11.2728249 L22.7736654,12.7468249 L26.1546654,12.7468249 L21.1398034,17.3517122 L22.5098034,18.7217122 L27.1926654,13.8568249 Z M13.8041608,13.8568249 L13.8041608,17.2418249 L12.3081608,17.2418249 L12.3081608,11.2728249 L18.3081608,11.2728249 L18.2231608,12.7468249 L14.8421608,12.7468249 L19.8570228,17.3517122 L18.4870228,18.7217122 L13.8041608,13.8568249 Z",
    id: ".._.._src_svg_Icn_40px_Bewegen__Shape",
    transform: "rotate(-45 20.498 19.465)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBewegen);
export default __webpack_public_path__ + "static/media/Bewegen.4215d5ae0738541525030a7a218c4b84.svg";
export { ForwardRef as ReactComponent };